/**
 * Submits the cart drawer's upsell forms without leaving the page.
 *
 * Without this the forms post to /cart/add and /cart/change, which respond
 * with a redirect to /cart — the customer loses their place on the product
 * page and the drawer closes. Progressive enhancement: if this script fails to
 * load the forms still work, they just navigate.
 */
(() => {
  const FORMS = '.ms-cart-upsell';
  const DRAWER_SECTION = 'cart-drawer-section';

  const jsonEndpoint = (action) => (action.includes('/cart/add') ? '/cart/add.js' : '/cart/change.js');

  /** Swap the drawer's contents, leaving the open <dialog> and its header alone. */
  const refreshDrawer = async () => {
    const res = await fetch(`${window.location.pathname}?sections=${DRAWER_SECTION}`);
    if (!res.ok) throw new Error(`section fetch failed: ${res.status}`);
    const data = await res.json();
    const html = data[DRAWER_SECTION];
    if (!html) throw new Error('section missing from response');

    const fresh = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('cart-items-component');
    const current = document.querySelector('#cart-drawer cart-items-component');
    if (!fresh || !current) throw new Error('cart-items-component not found');

    current.replaceChildren(...fresh.childNodes);
  };

  const updateBubble = (count) => {
    const bubble = document.querySelector('[ref="cartBubble"]');
    const number = document.querySelector('[ref="cartBubbleCount"]');
    if (number) number.textContent = String(count);
    if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
  };

  const submit = async (form) => {
    const button = form.querySelector('button[type="submit"]');
    const body = {};
    new FormData(form).forEach((value, key) => {
      body[key] = key === 'quantity' || key === 'line' || key === 'id' ? Number(value) : value;
    });

    button?.setAttribute('disabled', '');
    try {
      const res = await fetch(jsonEndpoint(form.action), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error(`cart request failed: ${res.status}`);
      const cart = await res.json();

      await refreshDrawer();
      // /cart/add.js returns the added line, not the cart, so fall back to a
      // read when item_count is absent.
      const count =
        typeof cart.item_count === 'number'
          ? cart.item_count
          : (await (await fetch('/cart.js')).json()).item_count;
      updateBubble(count);

      document.dispatchEvent(
        new CustomEvent('shopify:cart:lines-update', { bubbles: true, detail: { source: 'ms-cart-extras' } })
      );
    } catch (error) {
      console.warn('[ms-cart-extras]', error);
      // Fall back to the plain form post rather than leaving the click dead.
      form.submit();
    } finally {
      button?.removeAttribute('disabled');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof Element ? event.target.closest(FORMS) : null;
    if (!form) return;
    event.preventDefault();
    submit(form);
  });
})();
